import { defineMessages } from "react-intl"

const messages = defineMessages({
  signupBlankNameError: {
    id: "validation.signup-blank-name-error",
    defaultMessage: "Please enter a name"
  },
  invalidEmailError: {
    id: "validation.invalid-email-error",
    defaultMessage: "Please enter a valid email"
  },
  signupBlankPasswordError: {
    id: "validation.signup-blank-password-error",
    defaultMessage: "Please enter a password"
  },
  signupPasswordNotStrong: {
    id: "validation.signup-password-not-strong",
    defaultMessage: "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
  },
  signupInvalidPasswordLength: {
    id: "validation.signup-invalid-password-length",
    defaultMessage: "Password length should be between 14 and 128 characters"
  },
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/validations.js